import React from 'react';
// Components
import MainCta from '../cta/MainCta';
import WellnessInfoSection from './WellnessInfoSection';
import WellnessFaqSection from '../faq/WellnessFaqSection';
import WellnessJourneySection from './WellnessJourneySection';

function WellnessPageMainContainer() {
  return (
    <main role='main' className='grid gap-y-8 lg:gap-y-12 w-full h-full'>
      <WellnessJourneySection />
      <WellnessInfoSection />
      <MainCta />
      <WellnessFaqSection />
    </main>
  );
}

export default WellnessPageMainContainer;
